// Permet de gérer le paramétrage de Vue et intègre Axios

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Header from './components/SiteWeb/Header.vue'
import Footer from './components/SiteWeb/Footer.vue'

// Import du style CSS général
import '../src/styles/SCSS/styles.css'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.component('myHeader', Header)
Vue.component('myFooter', Footer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js